import { ProductDataResponse } from "@/app/alts/bullion/type-constants";

interface BullionPriceRequest {
    product_code: string;
    quantity?: string;
    time_frame?: string;
    unit_type?: string;
}
/* interface BullionPriceResponse {
    // Add specific response type fields based on the API response
    // This is a basic example, adjust according to actual response
    success: boolean;
    data: ProductData;
} */

interface data {
    products: BullionProduct[];
}
export interface BullionProduct {
    product_id: string;
    name: string;
    code: string;
    description: string;
    image: string;
    active: boolean;
    created_at: string;
    updated_at: string;
}
export interface BullionProductResponse {
    data: data;
    message: string;
    success: boolean;
}
/* interface Headers {
    [key: string]: string;
}

const requestHeaders: Headers = {
    "X-partner": getXPartner(),
};

const requestOptions: RequestInit = {
    headers: requestHeaders,
}; */

export async function getBullionProducts(): Promise<BullionProductResponse> {
    try {
        const response = await fetch(`${process.env.API_BASE_URL}/bullion/products`);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        return result;
    } catch (err) {
        console.error("Error fetching data:", err);
        throw err;
    }
}

export async function getBullionPrices(params: BullionPriceRequest): Promise<ProductDataResponse> {
    try {
        const url = `${process.env.API_BASE_URL}/bullion/products/${params.product_code}/prices?${params.quantity ? "quantity=" + params.quantity : ""}${params.time_frame ? "&time_frame=" + params.time_frame : ""}${params.unit_type ? "&unit_type=" + params.unit_type : ""}`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw error;
    }
}